import React from 'react';
import {toJS} from "mobx";
import {addError, BindedComponentError, clearError, getError} from "../../utils/error-utils";
import { BaseUIComponentProps } from '../metadata-components/BaseUIComponent';
import {FlatDomainDataContext, IDomainData} from '../../datatypes';
import { EventEmitter } from 'events';

export interface BaseBindedComponentProps extends BaseUIComponentProps{
    ctx: {
            listBinding?:string; 
            namePrefix?:string;
            triggers?:{parentTriggerEvent?: EventEmitter};
         } & FlatDomainDataContext;
    onChange: Function[];
}

export interface BaseBindedComponentState {
    validators?: Function[];
}

export default class BaseBindedComponent<P extends BaseBindedComponentProps, T extends BaseBindedComponentState> extends React.Component<P, T> {
  originalValue: any;

  constructor(props:P & {[key:string]:IDomainData}) {
    super(props);

    // do not create state in base react class!!!

    // TODO: it is safe???
    this.originalValue = toJS(this.getBindedValue());
    
    const domainAttribute = props.domainAttribute!;
    const formBean = props.formBean!;

    // when triggers are set???
    let triggers = props.ctx.triggers;
    if(triggers && triggers.parentTriggerEvent) {
        // console.debug(`ctx.trigers`, props.ctx.triggers);
        props.ctx.triggers!.parentTriggerEvent!.on('PARENT_TRIGGER_HIDE', () => {

        /* If component is hidden, unregister its isValid function from formBean.validators */
        let reducedValidators = formBean.validators.filter(v => v!==this.isValid);
        if (reducedValidators.length != formBean.validators.length)
          formBean.validators = reducedValidators; // avoid having new object everytime when the function is called

        /* delete from _errors */
        if((props[domainAttribute.objectName] as IDomainData)._errors && props[domainAttribute.objectName]._errors![domainAttribute.name]){
          props[domainAttribute.objectName]._errors![domainAttribute.name]= null;
        }
        (props[domainAttribute.objectName] as IDomainData)[domainAttribute.name] = this.originalValue;
      });
      // @ts-ignore
    //   console.debug(`register PARENT_TRIGGER_HIDE listenere on ${props.ctx.triggers!.parentTriggerEvent.__id}`);
    }

  }

  componentDidMount() {
    let {formBean}= this.props;
    formBean.validators.push(this.isValid)
  }

  getBindedValue() {
    const props = this.props as P & {[key:string]:IDomainData};
    let {domainAttribute}= this.props;
    return domainAttribute && props[domainAttribute.objectName]  ? props[domainAttribute.objectName][domainAttribute.name] : null;
  }

  getError(){
    const props = this.props as P & {[key:string]:IDomainData};
    const domainAttribute = this.props.domainAttribute!;
    return getError(props[domainAttribute.objectName], domainAttribute.name, this.props.metadata)
  }

  // TODO: mix state management by base react component is a big no-no!
  isValid = () => {
    const props = this.props as P & {[key:string]:IDomainData};

    if(this.state && this.state.validators && this.state.validators.length > 0){
      let arr = (this.state.validators||[]) as Function[];
      const domainAttribute = this.props.domainAttribute!;
      const metadata = props.metadata!;
      /*
       For addError -> sending _edgeName as objectName.
       For clearError -> using objectId and attrName to find it uniquely
       TODO: append objectParentName to the objectName if needed later.
      */
      let objectName = props[domainAttribute.objectName]._edgeName;
      let errorProps:BindedComponentError = {
        error: '',
        code: '',
        domainObject: props[domainAttribute.objectName],
        attrName: domainAttribute.name,
        formBean: this.props.formBean,
        objectName: objectName,
        objectId: props[domainAttribute.objectName].Id as string,
        metadata: metadata
      }

      for(let v of arr) {
        let err = v(props[domainAttribute.objectName][domainAttribute.name], this.props.formBean);
        errorProps.error = err;
        if (err) {
          addError(errorProps);
          return false;
        }
      }
      clearError(errorProps);
    }
    return true;
  }
  setBindedValue(value:any) {
    const props = this.props as P & {[key:string]:IDomainData};
    let {domainAttribute}= props;
    if (domainAttribute && props[domainAttribute.objectName]){
      props[domainAttribute.objectName][domainAttribute.name] = value;
    }

    if (this.props.onChange){
      for (let i = 0; i < this.props.onChange.length; i++) {
        this.props.onChange[i]();
      }
    }
  }

  onChangeHandler = (value:any, isBindValue?:boolean) => {
    if (isBindValue){ 
        this.setBindedValue(value)
    }
    this.isValid()
  }
}
